import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgScreenshotSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 25,
	viewBox: "0 0 23 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .871538,
			y: .620561,
			width: 19.5195,
			height: 20.4221,
			rx: 2.6891,
			stroke: "black",
			strokeWidth: 1.24112,
			strokeLinecap: "round",
			strokeDasharray: "2.48 4.14"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_2131_4809)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M19.8526 21.5902H9.36116C9.08291 21.5902 8.81605 21.4797 8.6193 21.283C8.42255 21.0862 8.31201 20.8193 8.31201 20.5411V13.1971C8.31201 12.9188 8.42255 12.652 8.6193 12.4552C8.81605 12.2585 9.08291 12.1479 9.36116 12.1479H11.4594L12.5086 10.5742H16.7052L17.7543 12.1479H19.8526C20.1309 12.1479 20.3977 12.2585 20.5945 12.4552C20.7912 12.652 20.9018 12.9188 20.9018 13.1971V20.5411C20.9018 20.8193 20.7912 21.0862 20.5945 21.283C20.3977 21.4797 20.1309 21.5902 19.8526 21.5902Z",
				fill: "black",
				stroke: "black",
				strokeWidth: 1.04915,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M14.6067 18.9672C15.9104 18.9672 16.9672 17.9104 16.9672 16.6067C16.9672 15.303 15.9104 14.2461 14.6067 14.2461C13.303 14.2461 12.2461 15.303 12.2461 16.6067C12.2461 17.9104 13.303 18.9672 14.6067 18.9672Z",
				stroke: "#E5E5E5",
				strokeWidth: 1.04915,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2131_4809",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16.7863,
				height: 16.7863,
				fill: "white",
				transform: "translate(6.21387 7.95312)"
			})
		}) })
	]
});
export default SvgScreenshotSymbol;
